module.exports = __webpack_public_path__ + "images/emoji/bee.0dfe0eee3d2d13171e1e.png";